/* eslint no-param-reassign: ["error", { "props": false }] */
import { getSearchObj } from '@tencent/magic-ui-util';
import { layoutConfig } from '../../container/src/formConfig';
import { YYB_APP_IDS } from '../../../src/constant/index';

const defaultBackgroundImageQuality = 50;
const location = window.location.href === 'about:blank' ? window.parent.location : window.location;
const params = getSearchObj(location.search);
export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [{
      text: 'type',
      name: 'type',
      type: 'hidden',
    }, {
      text: '页面标识',
      name: 'name',
      disabled: true,
      extra: '作为链接中的page参数的值，在多页面的情况下用来指定要打开的页面',
      rules: {
        validator: ({ value, callback }) => {
          if (!/^[0-9a-zA-Z\-_]{1,15}$/.test(value)) {
            callback(new Error('页面标识必须由英文字母、数字、下划线组成且不超过15个字符'));
          } else {
            callback();
          }
        },
        trigger: 'blur',
      },
    }, {
      text: '页面标题',
      name: 'title',
    },
    // {
    //   text: '进页面提醒',
    //   type: 'mod-select',
    //   modType: 59,
    //   name: 'notifyModId',
    // },
    {
      type: 'fieldset',
      text: '样式属性',
      items: [layoutConfig, {
        name: 'style',
        items: [{
          type: 'row',
          items: [{
            name: 'width',
            text: '宽度',
            disabled: YYB_APP_IDS.indexOf(params.appId?.toString()) > -1,
          }, {
            name: 'height',
            text: '高度',
          }],
        }, {
          type: 'row',
          items: [{
            name: 'min-width',
            text: '最小宽度',
          }, {
            name: 'min-height',
            text: '最小高度',
            type: 'hidden',
          }],
        }],
      }, {
        type: 'component',
        id: 'background',
        extend: [{
          name: 'backgroundImage',
          text: '背景图',
          cropType: 1, // 切割方式
          tooltip: YYB_APP_IDS.indexOf(params.appId?.toString()) > -1 ? '请确保上传的页面背景图符合规范（宽750、每屏不超过250KB）！' : '',
          strictNorm: YYB_APP_IDS.indexOf(params.appId?.toString()) > -1 ? {
            normWidth: 750,
            normHeight: 1500,
            recommendScreen: 3,
            maxScreen: 8,
            maxSizeScreen: 300,
            forbidList: ['image/png'],
          } : undefined,
        }, {
          // 自定义背景图尺寸，用于处理PC端场景下的背景图拉伸压缩的问题
          name: 'customBackgroundSize',
          text: '自定义背景图尺寸',
          type: 'select',
          defaultValue: (vm) => {
            if (vm.$store.state.EditorStore.pageType === 'PC') {
              return 'contain';
            }
            return '100% 100%';
          },
          options: [
            { value: '', text: '默认' },
            { value: '100% 100%', text: '100% 100%' },
            { value: 'cover', text: 'cover' },
            { value: 'auto', text: 'auto' },
            { value: 'contain', text: 'contain' },
          ],
        }],
      }, {
        name: 'isSetBackgroundImageQuality',
        text: '图片压缩',
        type: 'switch',
        defaultValue: false,
        onChange: (_, isSet, { model }) => {
          // 如果设置了图片质量，则取图片质量参数，否则取默认值
          const quality = isSet ? (model.backgroundImageQuality || defaultBackgroundImageQuality) : 0;
          model.backgroundImageQuality = quality;
          toggleBackgroundImageView2(model, quality, isSet);
        },
      }, {
        name: 'backgroundImageQuality',
        text: '图片质量',
        type: 'number',
        max: 100,
        min: 0,
        step: 1,
        defaultValue: defaultBackgroundImageQuality,
        // 如果没有设置图片压缩，不展示此选项
        display: (_, { model }) => model.isSetBackgroundImageQuality,
        extra: '数值越大，清晰度越高，但加载速度会越慢。一般调成 50 能满足业务需求，如果想要高清晰度，可以数值调大，最大值为 100',
        onChange(_, quality, { model }) {
          toggleBackgroundImageView2(model, quality, model.isSetBackgroundImageQuality);
        },
      }, {
        text: '宇宙版背景图',
        type: 'upload',
        drag: true,
        name: 'universalBgImage',
        extra: '图片尺寸：宽 1366，高自定义',
      }],
    }, {
      type: 'fieldset',
      text: '环境配置',
      items: [{
        name: 'isLandscape',
        text: '屏幕方向',
        type: 'radioGroup',
        defaultValue: false,
        options: [
          { value: false, text: '竖屏' },
          { value: true, text: '横屏' },
        ],
        display: (vm, { model }) => model.pageType !== 'PC',
      }, {
        name: 'supportEnv',
        text: '参与环境',
        type: 'select',
        defaultValue: 'all',
        options: [
          { value: 'all', text: '不限制' },
          { value: 'onlyApp', text: '仅APP内可参与' },
        ],
        extra: '仅APP内可参与: 在H5页面打开时，点击任意操作拉起APP到参与',
        display: (vm, { model }) => model.pageType !== 'PC',
      }, {
        name: 'screenOrientation',
        text: '屏幕方向提示',
        type: 'switch',
        defaultValue: false,
        display: (vm, { model }) => model.pageType !== 'PC',
      }, {
        name: 'webUrl',
        placeholder: '引导手机打开页面',
        extra: '引导手机打开页面',
        text: 'PC端地址',
        display: (vm, { model }) => model.pageType !== 'PC',
      }, {
        name: 'h5Url',
        placeholder: '移动端打开时调整的地址',
        extra: '移动端打开时调整的地址',
        text: 'H5地址',
        display: (vm, { model }) => model.pageType === 'PC',
      }, {
        name: 'checkAccount',
        placeholder: 'APP外页面唤起APP时，检查账号一致',
        text: '检查账号一致',
        type: 'select',
        defaultValue: 'no',
        options: [
          { text: '不检查', value: 'no' },
          { text: 'H5转APP时校验', value: 'app' },
        ],
        display: (vm, { model }) => model.pageType !== 'PC',
      }],
    }, {
      type: 'fieldset',
      name: 'checkAccountConfig',
      labelWidth: '80px',
      text: '检查账号相关配置',
      display: (vm, { model }) => model.checkAccount === 'app',
      items: [{
        name: 'scene',
        text: '场景',
        defaultValue: '活动参与账号',
      }, {
        name: 'btnText',
        text: '按钮文案',
        defaultValue: '切换到活动账号',
      }, {
        name: 'hint',
        text: '提示文字',
        defaultValue: '检测到您原先活动参与的账号是{{userType}}账号，是否切换至该账号？',
      }],
    }, {
      type: 'fieldset',
      labelWidth: '100px',
      text: '活动未开始',
      items: [{
        text: '活动未开始',
        name: 'beforeTime',
        type: 'select',
        options: [
          { text: '重定向', value: 'redirect' },
          { text: '弹窗', value: 'pop' },
          { text: '无', value: 'none' },
        ],
      }, {
        text: '文案',
        name: 'beforeText',
        display: (vm, { model }) => model.beforeTime === 'pop',
      }, {
        text: '跳转地址',
        display: (vm, { model }) => model.beforeTime !== 'none',
        name: 'beforeTourl',
      }],
    }, {
      type: 'fieldset',
      labelWidth: '100px',
      text: '活动结束后',
      items: [{
        text: '活动结束后',
        name: 'afterTime',
        type: 'select',
        options: [
          { text: '重定向', value: 'redirect' },
          { text: '弹窗', value: 'pop' },
        ],
      }, {
        text: '活动结束语',
        name: 'conclusion',
        display: (vm, { model }) => model.afterTime === 'pop',
      }, {
        text: '跳转地址',
        name: 'toUrl',
      }],
    }, {
      type: 'component',
      id: 'shareConfig',
    }, {
      name: 'devconfig',
      items: [{
        name: 'device',
        type: 'hidden',
        defaultValue: 'phone',
      }],
    }],
  }, {
    title: '高级',
    lazy: true,
    items: [{
      type: 'tab',
      active: '0',
      items: [{
        title: '属性',
        labelWidth: '100px',
        items: [{
          name: 'id',
          text: 'ID',
          type: 'display',
        }, {
          text: '外部css链接',
          name: 'cssFile',
        }, {
          text: 'className',
          name: 'className',
        }, {
          text: '强登录',
          name: 'needLogin',
          type: 'switch',
        }, {
          labelWidth: '80px',
          type: 'fieldset',
          text: '上报',
          name: 'report',
          extensible: true,
          items: [{
            type: 'row',
            items: [{
              type: 'switch',
              name: 'custom',
              defaultValue: false,
              text: '自定义',
              extra: '选择自定义后可以手动修改上报内容，关闭后会自动生成上报内容',
            }],
          }, {
            text: '页面上报',
            disabled: (vm, { values }) => !values?.report?.custom,
            name: 'pv',
          }],
        }],
      }, {
        title: 'created',
        lazy: true,
        items: [{
          name: 'created',
          type: 'code',
          height: '100%',
        }],
      }, {
        title: 'mounted',
        lazy: true,
        items: [{
          name: 'mounted',
          type: 'code',
          height: '100%',
        }],
      }, {
        title: 'style',
        lazy: true,
        items: [{
          name: 'style',
          type: 'code',
          language: 'json',
          height: '100%',
        }],
      }, {
        title: 'css',
        lazy: true,
        items: [{
          name: 'css',
          type: 'code',
          language: 'css',
          height: '100%',
        }],
      }, {
        title: '请求',
        lazy: true,
        labelWidth: '80px',
        items: [{
          type: 'groupList',
          name: 'requests',
          span: 12,
          row: [{
            name: 'name',
            text: 'name',
          }, {
            name: 'isMock',
            type: 'switch',
            text: 'mock',
            defaultValue: false,
          }, {
            name: 'mockData',
            type: 'code',
            language: 'json',
            text: 'mock数据',
            display: (vm, { model }) => model.isMock,
            height: '328px',
          }, {
            type: 'fieldset',
            text: '配置',
            labelWidth: '80px',
            name: 'options',
            items: [{
              name: 'url',
              text: 'url',
            }, {
              name: 'data',
              text: 'data',
              type: 'code',
              language: 'json',
              height: '180px',
            }, {
              name: 'type',
              text: '请求类型',
              type: 'select',
              options: [{
                text: 'GET',
                value: 'GET',
              }, {
                text: 'POST',
                value: 'POST',
              }],
            }, {
              text: '客服URL',
              name: 'kfUrl',
            }],
          }, {
            name: 'errorCode',
            type: 'table',
            columns: [{
              label: '错误码',
              name: 'code',
            }, {
              label: '提示',
              name: 'msg',
            }],
          }],
        }],
      }],
    }],
  }],
}];

/**
 * 切换背景图压缩比参数
 *
 * @param {Object} model 表单对象
 * @param {number} quality 压缩质量参数
 * @param {Boolean} isSet 是否设置压缩参数
 */
function toggleBackgroundImageView2(model, quality, isSet) {
  if (!/^\d+$/.test(`${quality}`)) {
    return;
  }

  const { backgroundImage, backgroundParts } = model.style;
  // 更新分割后的背景图
  backgroundParts?.forEach((imageSrc, index) => {
    if (/^http/.test(imageSrc)) {
      backgroundParts[index] = toggleImageView2Query(imageSrc, quality, isSet);
    }
  });

  // 处理原背景图
  if (backgroundImage && /^http/.test(backgroundImage)) {
    model.style.backgroundImage = toggleImageView2Query(backgroundImage, quality, isSet);
  }
}

function toggleImageView2Query(src, quality, isSet) {
  const imageView2Reg = /imageView2\/q\/\d+/;
  const imageView2 = `imageView2/q/${quality}`;

  if (isSet) {
    if (imageView2Reg.test(src)) {
      return src.replace(imageView2Reg, imageView2);
    }
    return appendQuery(src, imageView2);
  }

  // isSet === false

  if (imageView2Reg.test(src)) {
    return src.replace(imageView2Reg, '').replace(/\??&?$/, '');
  }

  return src;
}

function appendQuery(src, query) {
  return /\?/.test(src) ? `${src}&${query}` : `${src}?${query}`;
}
